import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OverlayModule } from '@angular/cdk/overlay';
import { NgxEditorModule } from 'ngx-editor';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ProgressSpinnerComponent } from 'src/app/shared/components/progress-spinner/progress-spinner.component';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { CoordinateComponent } from './component/coordinate/coordinate.component';
import { DatePickerComponent } from './component/date-picker/date-picker.component';
import { InputComponent } from './component/input/input.component';
import { RadioGroupComponent } from './component/radio-group/radio-group.component';
import { SelectComponent } from './component/select/select.component';
import { SlideToggleComponent } from './component/slide-toggle/slide-toggle.component';
import { TextEditorComponent } from './component/text-editor/text-editor.component';
import { TextAreaComponent } from './component/textarea/textarea.component';

@NgModule({
  declarations: [
    CheckboxComponent,
    CoordinateComponent,
    DatePickerComponent,
    InputComponent,
    RadioGroupComponent,
    SelectComponent,
    SlideToggleComponent,
    TextAreaComponent,
    TextEditorComponent,
  ],
  imports: [
    AngularMaterialModule,
    CommonModule,
    FormsModule,
    NgxEditorModule,
    NgxMaskDirective,
    NgxMaskPipe,
    OverlayModule,
    ProgressSpinnerComponent,
    ReactiveFormsModule,
  ],
  exports: [
    CheckboxComponent,
    CoordinateComponent,
    DatePickerComponent,
    InputComponent,
    RadioGroupComponent,
    SelectComponent,
    SlideToggleComponent,
    TextAreaComponent,
    TextEditorComponent,
  ],
  providers: [provideNgxMask()],
})
export class ProfetControlWidgetModule {}
